export default __webpack_public_path__ + "static/media/misc-books4-1440w.764d1d39.webp";